import { IdentificacionProspecto } from './identificacion-prospecto.class';
import { Ocupacion } from '../tipo/ocupacion.class';
import { DireccionProspecto } from './direccion-prospecto.class';
export class DatosPersonalesProspecto {

    primerNombre: String;
    segundoNombre: String;
    primerApellido: String;
    segundoApellido: String;
    numeroCelular: String;
    sexo: String;
    fechaNacimiento: Number;
    identificacion: IdentificacionProspecto;
    ocupacion: Ocupacion;
    paisOrigen: String;
    direcciones: DireccionProspecto[];

    constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/models/prospecto/datos-personales-prospecto.class.ts